import { gql } from "@apollo/client";

export const LINK_TRAVEL_TOKEN = gql`
	mutation linkTravelTokenM(
		$travelToken: InputTravelToken!
		$isMobileFareCard: Boolean
	) {
		linkTravelToken(
			travelToken: $travelToken
			isMobileFareCard: $isMobileFareCard
		)
	}
`;
